ApiPromise = require 'network/api-promise'
Promise = require 'bluebird'
_ = require 'underscore'
Backgrounds = require 'data/backgrounds'
Auth = require 'db/auth'
ModelLoader = require 'db/model-loader'
Util = require 'lib/util'
{ unsplashApi, toJson, constants } = require 'network/unsplash'
parseURL = require 'url-parse'

{ DEFAULT_COLLECTION_ID, PAGE_SIZE, RAW_PARAMS } = constants
PRELOAD_PHOTO_EXPIRATION = Util.getMs { hours: 1 }
PRELOAD_PERMISSION_EXPIRATION = Util.getMs { minutes: 1 }

expirePermissionCache = -> module.exports.preloadPermissions.cache = {}
bindOrganizationListListener = _.once -> Auth.me().organizationList.on 'add remove', expirePermissionCache

class Background
  @::isColor = false
  @::isPhoto = false

  constructor: (value, metadata) ->
    @value = value
    @metadata = metadata

class Color extends Background
  @::isColor = true

class Photo extends Background
  @::isPhoto = true

module.exports = Helpers =
  Color: Color,
  Photo: Photo,

  createPhotoFromResponse: (response) ->
    url = parseURL(response.urls.raw, true)
    _.extend(url.query, RAW_PARAMS)

    new Photo url.toString(), response

  createBackgroundStyle: (background, options) ->
    if background.isColor
      { backgroundColor: background.metadata.color }
    else if background.isPhoto
      { backgroundImage: "url('#{background.metadata.urls.small}')" }

  createColors: ->
    Object
      .keys(Backgrounds)
      .filter((key) -> Backgrounds[key].color?)
      .map((key) -> new Color key, Backgrounds[key])

  preloadPermissions: _.memoize (idOrg) ->
    # Expire memoization cache so we don't keep stale responses around too long
    bindOrganizationListListener()
    setTimeout expirePermissionCache, PRELOAD_PERMISSION_EXPIRATION

    orgs = Auth.me().organizationList.models

    promises = orgs.map (org) ->
      if org.get('memberships')? && org.get('products')? && org.isFeatureEnabled('restrictVis')
        Promise.resolve org
      else
        ModelLoader.loadOrganizationMinimal org.id

    if idOrg? and idOrg not in _.pluck(orgs, 'id')
      promises.push ModelLoader.loadOrganizationMinimal(idOrg)

    Promise.all(promises)

  preloadPhotos: _.memoize ->
    # Expire memoization cache so we don't keep stale responses around too long
    setTimeout (-> module.exports.preloadPhotos.cache = {}), PRELOAD_PHOTO_EXPIRATION

    unsplashApi
      .collections
      .getCollectionPhotos DEFAULT_COLLECTION_ID, 1, PAGE_SIZE, 'latest'
      .then toJson
      .then (response) ->
        # Preload photos visible on initial create board screen then resolve with the initial response
        Promise.map(response.slice(0, 4), (photo) -> Util.waitForImageLoad photo.urls.small).then -> response

  preloadData: ->
    @preloadPermissions()
    @preloadPhotos()



// WEBPACK FOOTER //
// ./app/scripts/views/board-create/helpers.coffee